export default __webpack_public_path__ + "static/KeywordResearch_01_03@2x-d26839399575c4e7b301f4c88f527d96.webp";